import { render, staticRenderFns } from "./locationVisitsWidget.vue?vue&type=template&id=74bf1630&scoped=true"
import script from "./locationVisitsWidget.vue?vue&type=script&lang=js"
export * from "./locationVisitsWidget.vue?vue&type=script&lang=js"
import style0 from "./locationVisitsWidget.vue?vue&type=style&index=0&id=74bf1630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf1630",
  null
  
)

export default component.exports